// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f8ced6ab","488":"e7fe8faf","977":"93f615cc"}[chunkId] + ".chunk.js";
};